import moment from "moment";

export const helpers = {
  formatDate,
  formatDateHour,
  formatDateHourMinuteSecond,
  validateUserName,
  validatePhoneFormat,
  validateEmailFormat,
  like,
  standardlizePhoneNumber,
  compareList,
  compareListByName,
  currencyFormat,
  deleteSign,
  isDirtyForm
};

function formatDate(date) {
  return moment(date).format("DD/MM/YYYY");
}

function formatDateHour(time) {
  return moment(time).format("HH[h] DD/MM/YYYY");
}

function formatDateHourMinuteSecond(time) {
  return moment(time).format("DD/MM/YYYY HH:mm:ss");
}

function validateUserName(value) {
  value = value.trim().replace(/\s+/g, "");
  let re = /[^a-z0-9_]/;
  return re.test(value);
};

function validatePhoneFormat(value) {
  if (!value) return true;
  value = value.trim().replace(/\s+/g, "");
  let regex = /^\+?(0|84)?\d{9,12}$/;
  return regex.test(value);
};

function validateEmailFormat(value, callbackFnWhenFalse) {
  let re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
  return re.test(value.toLowerCase());

};

function like(sentence, phrase) {
  if (!sentence || !sentence.trim()) return false;
  if (!phrase || !phrase.trim()) return true;
  sentence = sentence.trim().toLowerCase();
  phrase = phrase.trim().toLowerCase();
  let words = phrase.split(/\s+/);
  let likeRegex = words.join(".*");
  return new RegExp(likeRegex).test(sentence);
};

function standardlizePhoneNumber(value) {
  value = value.trim().replace(/\s+/g, "");
  if (value.length === 9) return "0" + value;
  if (value.startsWith("0")) return "0" + value.substring(1);
  if (value.startsWith("84")) return "0" + value.substring(2);
  if (!value.startsWith("+84")) return "0" + value;
  return value;
};

function compareList(item1, item2) {
  if (!item1.id) return 1;
  if (!item2.id) return -1;
  if (item1.order !== item2.order)
    return (item1.order ? item1.order : item1.order === 0 ? 0 : 10000) > (item2.order ? item2.order : item2.order === 0 ? 0 : 10000) ? 1 : -1;
  return (item1.name || "").localeCompare(
    item2.name || ""
  );
};

function compareListByName(item1, item2, varName) {
  if (varName) return (item1[varName] || "").localeCompare(
    item2[varName] || ""
  )
  return (item1.name || "").localeCompare(
    item2.name || ""
  );
};

function currencyFormat(num, check, limit) {
  if (!num && num !== 0) return null;
  if (check && (num * 100) % 100 !== 0) {
    return parseFloat(num.toFixed(limit))
      .toString();
  } else {
    return num
      .toFixed(0)
      .toString()
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
  }
};

function deleteSign(str) {
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  str = str.replace(/đ/g, "d");
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
  str = str.replace(/Đ/g, "D");
  return str;
}

function isDirtyForm(values) {
  let formDirty = false;
  Object.keys(values).forEach(item => {
    if (values[item] !== null && values[item] !== undefined && (Object.keys(values[item])?.length || values[item])) {
      formDirty = true;
    }
  })

  return formDirty;
}